export default __webpack_public_path__ + "static/media/ic_turks_and_caicos.fb388b53.svg";